var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 62415"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1334",
    opacity: 0.2,
    cx: 110,
    cy: 110,
    r: 110,
    fill: "#2E6DFA"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1333",
    opacity: 0.4,
    cx: 110,
    cy: 110,
    r: 85.3731,
    fill: "#2E6DFA"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1330",
    cx: 109.748,
    cy: 109.964,
    r: 56.3896,
    fill: "#2E6DFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1329",
    opacity: 0.2,
    d: "M96.8997 129.236C102.61 154.933 140.891 166.353 109.748 166.353C78.6049 166.353 53.3584 141.107 53.3584 109.964C53.3584 78.8207 78.6049 53.5742 109.748 53.5742C49.0756 89.2638 99.7549 107.109 96.8997 129.236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1332",
    opacity: 0.1,
    d: "M119.631 88.3774C104.758 96.3911 101.788 56.2387 124.81 56.2387C126.886 55.7049 153.289 63.5662 163.283 92.1181C171.343 122.2 159.717 87.838 158.292 103.528C156.151 73.548 134.505 80.3638 119.631 88.3774Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Icon);
export default __webpack_public_path__ + "static/media/404-icon.af8bbd9e62c623a72524692389cc057d.svg";
export { ForwardRef as ReactComponent };